import React from 'react';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        sumOrient = (
            <>
                <div>{(model.getMinSumEdge()).toLocaleString('uk-UA') + ' ' + calc.l10n('UAH_ICON')}</div>
                <div>{(model.getMaxSumEdge() / 2).toLocaleString('uk-UA') + ' ' + calc.l10n('UAH_ICON')}</div>
                <div>{(model.getMaxSumEdge()).toLocaleString('uk-UA') + ' ' + calc.l10n('UAH_ICON')}</div>
            </>
        ),
        termOrient = (
            <>
                <div>{(model.getMinTermEdge())}</div>
                <div>{(model.getMinTermEdge() * 4)}</div>
                <div>{(model.getMaxTermEdge())}</div>
            </>
        );

    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <h2 className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</h2>
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CREDIT_PBP_SUM')}
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="creditSum" type="text"
                                   className="calculator-slider-value"
                                   value={model.getCreditSum().toLocaleString('uk-UA')}
                                   onChange={calc.handleChangeInput}
                                   onBlur={calc.blurChangeInput}
                                   max={model.getMaxSumEdge()}
                                   min={model.getMinSumEdge()}>
                            </input>
                          <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
                          <span style={{left: `${calc.state.valueWith + 10}px`}}>{calc.l10n('UAH_ICON')}</span>
                        </div>
                        <input type="range"
                               name="creditSum"
                               className="calculator-sum-slide"
                               onChange={calc.handleChange}
                               value={model.getCreditSum()}
                               min={model.getMinSumEdge()}
                               max={model.getMaxSumEdge()}
                               step={model.getSumStep()}
                               style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent}%)`}}
                        />

                    </div>
                    <div className="calculator-slider-orient">
                        {sumOrient}
                    </div>
                </div>
                <div className="controller-block  ">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_FORM')}
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditTerm()} {calc.l10n('CALCULATOR_MONTH')}
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="creditTerm"
                                className="calculator-sum-slide"
                                onChange={calc.handleChange1}
                                value={model.getCreditTerm()}
                                min={model.getMinTermEdge()}
                                max={model.getMaxTermEdge()}
                                step="1"
                                style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent1}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent1}%)`}}

                            />
                        </div>
                        <div className="calculator-slider-orient">
                            {termOrient}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
